<template>
  <!-- 组织机构 -->
 <div class="treeBigBox app-container">
    <!--树形结构-->
    <div class="box">
      <div class="title">
        <div class="xian"></div>
        <div>一级名称</div>
      </div>
      <div class="treeBox">
        <div style="padding: 10px;    text-align: left;">
          <el-button type="primary" v-if="btnFlg[1]"  @click="addClick(1)" >新增</el-button>
        </div>
        <el-tree :data="data"
          node-key="id"
          ref="orgTree"
          :props="defaultProps"
          :default-expand-all="false"
          :expand-on-click-node="false"
          :current-node-key="currentData.parentId"
          :highlight-current="true"
           :render-content="renderContent"
          @node-click="handleNodeClick">
        </el-tree>
      </div>
    </div>
    <!--详情标题-->
    <div class="right">
      <div class="title">
        <div class="xian"></div>
        <div>详情</div>
      </div>

      <div>
         <div class="centerBox">
         <div class="rightTop">
            <h4 ref="shangJiName" style="padding: 0;padding-right: 10px;">{{currentData.title}}</h4>
            <el-button type="primary" v-if="btnFlg[1]"  @click="addClick(2)" >新增</el-button>
         </div>
      <!--详情-->
      <div class="xiangQingBox">
          <!--  表格 -->
        <div class="table" :style="{height:h}">
          <el-table :data="tableList"  ref="table"   v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
            @row-click="handleRowClick"  height="100%" style="width: 100%" center border class="tableComent">
            <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
            <el-table-column label="操作" width="120" >
              <template slot-scope="scope">
                <div>
                  <el-button type="text" size="mini" v-if="btnFlg[2]"  @click="editFn(scope.row,2)">修改</el-button>
                  <el-button type="text" size="mini" v-if="btnFlg[3]" @click="delFn(scope.row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" min-width="220"  label="名称" :formatter="emptyFn" show-overflow-tooltip></el-table-column>
            <el-table-column prop="incomeExpenseType" width="150" label="现金流类型">
              <template slot-scope="scope">
                  <span>{{['现金流入' ,'现金流出'][scope.row.cashFlowType-1]}}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="code" width="170"   label="编码" :formatter="emptyFn"></el-table-column> -->
            <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
            <el-table-column prop="updateUserName" label="修改人"  width="120" :formatter="emptyFn"></el-table-column>
            <el-table-column prop="updateTime" width="170" :formatter="dateTimeFormat"  label="修改时间"></el-table-column>
          </el-table>
        </div>
      </div>
      </div>
      </div>
    </div>
    <!-- 添加机构 -->
    <el-dialog  :title="title1"  :visible.sync="addMark" width="480px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="addFrom" ref="addFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="150px" size="mini">
        <div class="inpBox">
          <div style="margin: 28px 0">
              <!-- <el-form-item label="级别:" prop="orgType">
                <el-select  v-model="addFrom.orgType"  placeholder="请选择" >
                  <el-option
                    v-for="item in agencyType"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                   >
                  </el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="名称:" prop="name">
                <el-input   maxlength="100" placeholder=""   v-model.trim="addFrom.name"></el-input>
              </el-form-item>
              <el-form-item label="现金流类型:" prop="cashFlowType" v-if="addFrom.orgType==2">
                <el-select  v-model="addFrom.cashFlowType" placeholder="请选择" size="mini">
                  <el-option label="现金流入" value="1" ></el-option>
                  <el-option label="现金流出" value="2" ></el-option>
                </el-select>
               </el-form-item>
          </div>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addMark = false">取消</el-button>
        <el-button type="primary" @click="addSave()" v-show="addBtnShow">确定</el-button>
        <el-button type="primary" @click="editSave()" v-show="editBtnShow">修改</el-button>
      </span>
   </el-dialog>
 </div>
</template>

<script>
import {
  findCashFlowItemList, // 结构树
  saveCashFlowItemList, // 添加
  updateCashFlowItemList, // 修改
  deleteCashFlowItemList // 删除
} from '@/api/common-signature'
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
export default {
  data () {
    return {
      currentData: {}, // 当前选中
      addFrom: {},
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      tableList: [],
      loading: false,
      title1: '',
      // 组织机构树
      data: [],
      defaultProps: {
        label: 'name',
        children: 'children'
      },
      agencyType: [
        { name: '一级', id: 1 },
        { name: '二级', id: 2 }
      ],
      h: '500px',
      // 添加机构
      addMark: false,
      addBtnShow: false,
      editBtnShow: false,
      // 新增验证
      rules: {
        cashFlowType: [
          { required: true, message: '请选择现金流类型', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入机构名称', trigger: 'blur' }
        ]
      },
      // 按钮
      btnFlg: [],
      btnIdArr: ['00FM0S0100', '00FM0S0200', '00FM0S0300', '00FM0S0400']
    }
  },
  created () {
    this.getTree(true)
  },
  mounted () {
    let pH = document.documentElement.clientHeight
    this.h = (pH - 235) + 'px'
    this.btnFlg = getBtn(this.btnIdArr)
  },
  methods: {
    renderContent (h, { node, data, store }) {
      return (
        <span class="custom-tree-node" style="display: flex; align-items: center; gap: 8px; width: 100%;padding:10px">
          <span style="flex: 1;text-align: left;">{node.label}</span>
          {/* 修改按钮 - 文字图标版，小尺寸文字按钮 */}
          { this.btnFlg[2] ? (<el-button
            type="text"
            size="small"
            icon="el-icon-edit"
            onClick={(e) => { e.stopPropagation(); this.editFn(data) }}
          >修改</el-button>) : null}
          {/* 删除按钮 - 危险色区分，小尺寸文字按钮 */}
          { this.btnFlg[3] ? (<el-button
            type="text"
            size="small"
            icon="el-icon-delete"
            style="color: #f56c6c;"
            onClick={(e) => { e.stopPropagation(); this.delFn(data) }}
          >删除</el-button>) : null}
        </span>
      )
    },
    // 选择数据
    selectGoods (selection) {
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },

    // 获取左侧菜单
    getTree (flag) {
      findCashFlowItemList().then((res) => {
        if (res && res.length > 0) {
          this.data = res
          if (flag) {
            this.currentData = {
              title: res[0].name,
              parentId: res[0].id
            }
          }
          this.$nextTick(function () {
            if (this.$refs.orgTree) {
              this.$refs.orgTree.setCurrentKey(this.currentData.parentId)
              this.tableList = this.$refs.orgTree.getNode(this.currentData.parentId).data.children
            }
          })
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 点击树
    handleNodeClick (data) {
      this.tableList = data.children
      this.currentData = {
        title: data.name,
        Type: data.orgType,
        parentId: data.id
      }
    },
    // 添加机构
    addClick (n) {
      this.title1 = '添加机构'
      this.addMark = true
      this.addBtnShow = true
      this.editBtnShow = false
      this.addFrom.orgType = n
    },
    addSave () {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (this.addFrom.orgType == 1) {
            this.$set(this.addFrom, 'parentId', null)
          } else {
            this.$set(this.addFrom, 'parentId', this.currentData.parentId)
          }

          saveCashFlowItemList(this.addFrom).then(res => {
            loading.close()
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.addMark = false
            this.getTree()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 修改
    editFn (row, n) {
      this.title1 = '修改机构'
      this.addBtnShow = false
      this.editBtnShow = true
      this.addMark = true
      this.addFrom = { ...row }
      this.addFrom.orgType = n
    },
    editSave () {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          updateCashFlowItemList(this.addFrom).then(res => {
            loading.close()
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.addMark = false
            this.getTree()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        deleteCashFlowItemList({ ids: [row.id] }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getTree()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    closeDialog () {
      this.addFrom = {}
      this.$refs['addFrom'].resetFields()
    }

  }
}
</script>

<style scoped lang='less'>
  .treeBigBox{
    display:flex;
  }
  .treeBox{
    text-align: center;
    height: calc(100vh - 164px);
    overflow: auto;
  }
  .centerBox{
    width:100%;
    height:100%;
  }
  .xiangQingBox{
    margin-top: 10px;
  }
 .demo-form-inline .el-form-item{
  margin-bottom: 17px!important;
}
.rightTop{
  display: flex;
  padding: 0 30px;
  align-items: center;
  h4{
    padding-right: 30px;
  }
}
.title{
  width: 100%;
  height: 36px;
  background: #D8E3F8;
  display: flex;
  align-items: center;
  padding-left: 20px;
  box-sizing: border-box;
  font-size: 14px;
  .xian{
    width: 4px;
    height: 16px;
    border-radius: 2px;
    background-color: rgba(11, 79, 214, 100);
    margin-right: 4px;
  }
}
.right{
  // flex: 1;
  // width: 75%;
  width: calc(100% - 361px);
}
.box{
  width: 360px;
  // width:30%;
  border-right: 1px dashed #ddd;
}
/deep/.el-tree-node__content{
  white-space: nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
/deep/.inpBox .el-input__inner {
    width: 224px;
}
/deep/.el-tree{
  height: 100%;
}
/deep/ .el-tree-node__expand-icon {
  display: none !important;
}
</style>
